// extracted by mini-css-extract-plugin
export default {"content":"Detail_content__2uCy+","basicTitle":"Detail_basicTitle__PUDqg","stickyShadowFooter":"Detail_stickyShadowFooter__wFhYp"};